import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import { Typography } from "@mui/material";
import { sendSignInLinkToEmail } from "firebase/auth";
import { auth } from "utils/firebase";
import { useSuccess } from "hooks/SuccessContext";
import { useState } from "react";
import UserApi from "apis/UserApi";
import { useError } from "hooks/ErrorContext";
export const EmailInput = () => {
  const [email, setEmail] = useState("");
  const { showMessage } = useSuccess();
  const { showError } = useError();


  const sendLoginEmail = async (email) => {
    try {

     const apiRes = await UserApi.sendForgotPasswordEmail({ email });
     showMessage("Password reset email sent! Please check your inbox.");
    } catch (error) {
      showError("Failed to send password reset email");
    }
  };
  return (
    <MKBox pt={4} pb={3} px={3}>
      <Card
        sx={{
          backgroundColor: "#e4edff",
          padding: 2, // Equivalent to padding: 10px
          marginBlock: 2,
          textAlign: "center",
        }}
      >
        {" "}
        <Typography variant="h6" component="p">
          Please provide your registered email for password reset
        </Typography>{" "}
      </Card>

      <MKBox component="form" role="form">
        <MKBox mb={2}>
          <MKInput
            label="Email"
            fullWidth
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </MKBox>

        <MKBox mt={4} mb={1}>
          <MKButton variant="gradient" color="info" fullWidth onClick={() => sendLoginEmail(email)}>
            Verify
          </MKButton>
        </MKBox>
      </MKBox>
    </MKBox>
  );
};
